import * as PIXILib from 'pixi.js';
import * as PIXISoundLib from 'pixi-sound';

const PIXI = {...PIXILib, ...PIXISoundLib};

export { PIXI };
